export default ".dynamic-body{display:flex;flex:1}.dynamic-body .n-form-item{flex:1}"